// DEPENDENCIES
//// Angular
import { inject, Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of, switchMap, withLatestFrom } from "rxjs";
//// Local
import { AppState } from "../root";
import { RuleActions } from "./rule.actions";
import { selectLoggedInUser } from "../user/user.selectors";
import { deleteRuleTemplate, loadRuleTemplates, storeRuleTemplate } from "./helpers";
import { IRule } from "../../models/rule.interface";
import { defaultMaxListeners } from "events";


@Injectable()
export class RuleEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<AppState>);

  loadRuleTemplates$ = createEffect(() => this.actions$.pipe(
    ofType(RuleActions.loadRuleTemplates),
    withLatestFrom(this.store$.select(selectLoggedInUser)),
    switchMap(([_, user]) => {
      const ruleTemplates: IRule[] = loadRuleTemplates(user!)
      return of(RuleActions.loadRuleTemplatesSuccess({ rules: ruleTemplates }))
    })
  ))

  addRuleTemplate$ = createEffect(() => this.actions$.pipe(
    ofType(RuleActions.addRuleTemplate),
    withLatestFrom(this.store$.select(selectLoggedInUser)),
    switchMap(([action, user]) => {
      storeRuleTemplate(user!, action.rule)
      return of(RuleActions.loadRuleTemplates())
    })
  ));

  updateRuleTemplate$ = createEffect(() => this.actions$.pipe(
    ofType(RuleActions.updateRuleTemplate),
    withLatestFrom(this.store$.select(selectLoggedInUser)),
    switchMap(([action, user]) => {
      deleteRuleTemplate(user!, action.originalRule)
      storeRuleTemplate(user!, action.rule)
      return of(RuleActions.loadRuleTemplates())
    })
  ));

  deleteRuleTemplate$ = createEffect(() => this.actions$.pipe(
    ofType(RuleActions.deleteRuleTemplate),
    withLatestFrom(this.store$.select(selectLoggedInUser)),
    switchMap(([action, user]) => {
      deleteRuleTemplate(user!, action.rule)
      return of(RuleActions.loadRuleTemplates())
    })
  ));
}
